import React from "react";
import { motion } from "framer-motion";
import { FlaskConical, Atom, DatabaseZap } from "lucide-react";

const UnlockingIntelligence: React.FC = () => {
  return (
    <section className="py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="text-center mb-12"
      >
        <h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl mb-6">
          The hidden intelligence in your chemical data
        </h2>
        <p className="text-gray-300 text-lg leading-relaxed max-w-3xl mx-auto">
          Vast volumes of valuable scientific data often lie dormant, locked
          away in legacy systems, spreadsheets, and lab notebooks. We've built a
          breakthrough suite of tools to revive and unify that data.
        </p>
      </motion.div>

      <div className="max-w-5xl mx-auto">
        {/* Key Capabilities - Horizontal Pills */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          className="flex flex-wrap justify-center gap-4"
        >
          <div className="flex items-center gap-3 px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:border-[#00A3FF]/50 transition-colors duration-300">
            <FlaskConical className="w-5 h-5 text-[#00A3FF]" strokeWidth={1.5} />
            <span className="text-white text-sm font-medium">
              Lab Data Extraction
            </span>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:border-[#00A3FF]/50 transition-colors duration-300">
            <Atom className="w-5 h-5 text-[#00A3FF]" strokeWidth={1.5} />
            <span className="text-white text-sm font-medium">
              Chemical Structure Recognition
            </span>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:border-[#00A3FF]/50 transition-colors duration-300">
            <DatabaseZap className="w-5 h-5 text-[#00A3FF]" strokeWidth={1.5} />
            <span className="text-white text-sm font-medium">
              Semantic Linking
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UnlockingIntelligence;
